// extracted by mini-css-extract-plugin
module.exports = {"headerBanner":"header-banner_headerBanner__8rAPx","imageDesktop":"header-banner_imageDesktop__5LyB1","imageMobile":"header-banner_imageMobile__xvmEg"};